import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed, lazyWithRetry } from "src/utils/lazy-named";

const profilesImport = () => import("./profiles");
const Profiles = lazyWithRetry(profilesImport);

export const preloads: RoutePreload[] = [["/profiles", profilesImport]];
const ProfilesTable = lazyNamed(
  () => import("./profiles-table"),
  "ProfilesTable",
);

export const routes: Array<RouteObject> = [
  {
    path: "profiles",
    spacesAccess: "hidden-from-limited-view",
    element: <Profiles />,
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <ProfilesTable />,
      },
    ],
  },
];
